import React, { useEffect, useState } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { ZoomIn, ZoomOut } from '@mui/icons-material';

const MIN_ZOOM = 100;
const MAX_ZOOM = 200;
const ZOOM_STEP = 25;

/**
 * 모바일 PDF iframe. 브라우저 뷰어에 확대·축소 버튼이 없어서 위에 둔다.
 * iframe 에 transform 을 주면 뷰어 터치가 죽으므로, 칸 크기만 키운다.
 */
const MobilePdfPreview = ({ src, title = '문서', minFrameHeight = 0 }) => {
  const [zoom, setZoom] = useState(MIN_ZOOM);

  useEffect(() => {
    setZoom(MIN_ZOOM);
  }, [src]);

  return (
    <Box
      sx={{
        flex: 1,
        alignSelf: 'stretch',
        minWidth: 0,
        minHeight: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: 'background.paper',
      }}
    >
      <Box
        sx={{
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          gap: 0.5,
          px: 0.5,
          height: 40,
          borderBottom: 1,
          borderColor: 'divider',
        }}
      >
        <IconButton
          size="small"
          aria-label="축소"
          disabled={!src || zoom <= MIN_ZOOM}
          onClick={() => setZoom((current) => Math.max(MIN_ZOOM, current - ZOOM_STEP))}
        >
          <ZoomOut fontSize="small" />
        </IconButton>
        <Typography variant="caption" sx={{ minWidth: 40, textAlign: 'center' }}>
          {zoom}%
        </Typography>
        <IconButton
          size="small"
          aria-label="확대"
          disabled={!src || zoom >= MAX_ZOOM}
          onClick={() => setZoom((current) => Math.min(MAX_ZOOM, current + ZOOM_STEP))}
        >
          <ZoomIn fontSize="small" />
        </IconButton>
      </Box>
      <Box sx={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
        {src && (
          <iframe
            title={title}
            src={src}
            style={{
              display: 'block',
              border: 0,
              width: `${zoom}%`,
              height: `${zoom}%`,
              // 칸이 낮으면 브라우저 PDF 툴바를 그리지 않는다. 보이는 영역보다 프레임을 길게 둔다.
              minHeight: minFrameHeight > 0 ? (minFrameHeight * zoom) / 100 : undefined,
            }}
          />
        )}
      </Box>
    </Box>
  );
};

export default MobilePdfPreview;
